import { DEFAULT_TAX_BILLING_ADDRESS } from '@proton/payments/core/billing-address/billing-address';
import { CYCLE, PLANS } from '@proton/payments/core/constants';
import { getDefaultMainCurrency } from '@proton/payments/core/currencies';
import type { Cycle, PaymentStatus } from '@proton/payments/core/interface';
import { FREE_PLAN, getFreeCheckResult } from '@proton/payments/core/subscription/freePlans';
import { Audience } from '@proton/shared/lib/interfaces';

import type { SubscriptionData } from '../signup/interfaces';
import { type SignupModelV2, Steps, type Upsell, UpsellTypes } from './interface';

const getDefaultSubscriptionData = (cycle: Cycle): SubscriptionData => {
    return {
        skipUpsell: false,
        currency: getDefaultMainCurrency(),
        cycle,
        planIDs: {},
        checkResult: getFreeCheckResult(),
        billingAddress: DEFAULT_TAX_BILLING_ADDRESS,
    };
};

const getOptimisticPaymentMethods = (): PaymentStatus => {
    return {
        VendorStates: {
            Google: true,
            Card: true,
            Paypal: true, // We guess that card, Google and PayPal are active by default
            Apple: false,
            Cash: false,
            Bitcoin: false,
            Ideal: false,
        },
        CountryCode: DEFAULT_TAX_BILLING_ADDRESS.CountryCode,
        State: DEFAULT_TAX_BILLING_ADDRESS.State,
        ZipCode: DEFAULT_TAX_BILLING_ADDRESS.ZipCode,
    };
};

const subscriptionDataCycleMapping = {
    [PLANS.FREE]: {
        [CYCLE.MONTHLY]: getDefaultSubscriptionData(CYCLE.MONTHLY),
        [CYCLE.YEARLY]: getDefaultSubscriptionData(CYCLE.YEARLY),
        [CYCLE.TWO_YEARS]: getDefaultSubscriptionData(CYCLE.TWO_YEARS),
        [CYCLE.FIFTEEN]: getDefaultSubscriptionData(CYCLE.FIFTEEN),
        [CYCLE.THIRTY]: getDefaultSubscriptionData(CYCLE.THIRTY),
    },
};

const defaultUpsell: Upsell = {
    mode: UpsellTypes.PLANS,
    currentPlan: undefined,
    unlockPlan: undefined,
    plan: undefined,
    addons: undefined,
    subscriptionOptions: {},
};
export const defaultSignupModel: SignupModelV2 = {
    session: undefined,
    domains: [],
    subscriptionData: subscriptionDataCycleMapping[PLANS.FREE][CYCLE.YEARLY],
    subscriptionDataCycleMapping,
    subscriptionDataCycleMappingByCurrency: [],
    paymentStatus: getOptimisticPaymentMethods(),
    humanVerificationMethods: [],
    humanVerificationToken: '',
    selectedProductPlans: {
        [Audience.B2C]: PLANS.MAIL,
        [Audience.B2B]: PLANS.MAIL_PRO,
        [Audience.FAMILY]: PLANS.FAMILY,
    },
    freePlan: FREE_PLAN,
    upsell: defaultUpsell,
    inviteData: undefined,
    plans: [],
    plansMap: {},
    referralData: undefined,
    step: Steps.Account,
    cache: undefined,
    optimistic: {},
    loadingDependencies: true,
    initialBillingAddress: DEFAULT_TAX_BILLING_ADDRESS,
};
